import React from "react";
import { Clock, Store } from "lucide-react";
import { RankingMetricasPeriodo } from "../types";

interface HeaderProps {
  selectedPeriod: RankingMetricasPeriodo;
  selectedPeriodLabel: string;
  comparisonPeriodLabel: string;
  dateLabel: string;
  comparisonDateLabel: string;
  selectedLojaId?: number;
  selectedLojaNome?: string;
}

export const Header: React.FC<HeaderProps> = ({
  selectedPeriod,
  selectedPeriodLabel,
  comparisonPeriodLabel,
  dateLabel,
  comparisonDateLabel,
  selectedLojaId,
  selectedLojaNome,
}) => {
  return (
    <div className="mt-1.5 shrink-0 px-2 py-0.5 text-center sm:mt-2 sm:px-3 sm:py-1">
      <h1 className="mb-0.5 bg-gradient-to-r from-yellow-300 to-white bg-clip-text text-xl font-black leading-tight text-transparent sm:text-3xl">
        MÉTRICAS DE QUALIDADE
      </h1>
      <div className="mb-6 flex flex-col items-center justify-center gap-1 text-xs opacity-90 sm:flex-row sm:flex-wrap sm:gap-2 sm:text-sm">
        <span className="flex items-center gap-1.5 text-xs text-white/75 sm:text-sm">
          <Clock className="h-3.5 w-3.5 shrink-0 sm:h-4 sm:w-4" aria-hidden />
          {selectedPeriodLabel}: {dateLabel}
        </span>
        {selectedPeriod !== "dia" && (
          <span className="flex items-center gap-1.5 text-xs text-white/65 sm:text-sm">
            <Clock className="h-3.5 w-3.5 shrink-0 sm:h-4 sm:w-4" aria-hidden />
            {comparisonPeriodLabel}: {comparisonDateLabel}
          </span>
        )}
        {selectedLojaId && selectedLojaNome && (
          <span className="flex items-center gap-1.5 text-white/75">
            <Store className="h-3.5 w-3.5 sm:h-4 sm:w-4" aria-hidden />
            {selectedLojaNome}
          </span>
        )}
      </div>
    </div>
  );
};
